import { render, staticRenderFns } from "./promo-form.vue?vue&type=template&id=69fa64b4&"
import script from "./promo-form.vue?vue&type=script&lang=js&"
export * from "./promo-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports